module.exports = __webpack_public_path__ + "static/media/LeBlanc.03e85e0d.png";